export default __webpack_public_path__ + "static/media/carbon_checkmark-outline.b1de30c0.svg";